// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__1fTT9","frame":"Dialog_frame__2Q5wS","closeButton":"Dialog_closeButton__1UiuJ","okButton":"Dialog_okButton__2odju","body":"Dialog_body__uNnIq"};